import styled from 'styled-components';

import proWithMedalDesktop2x from '@front/common/src/assets/images/pro-with-medal-desktop@2x.jpg';
import proWithMedalDesktop3x from '@front/common/src/assets/images/pro-with-medal-desktop@3x.jpg';
import proWithMedalDesktop from '@front/common/src/assets/images/pro-with-medal-desktop.jpg';
import proWithMedalMobile2x from '@front/common/src/assets/images/pro-with-medal-mobile@2x.jpg';
import proWithMedalMobile3x from '@front/common/src/assets/images/pro-with-medal-mobile@3x.jpg';
import proWithMedalMobile from '@front/common/src/assets/images/pro-with-medal-mobile.jpg';
import type { UniverseReference } from '@front/common/src/types/commons';

import { translate } from '@front/i18n';

import Text from '@front/web-ui/src/components/base-text/variants/text';
import Image from '@front/web-ui/src/components/image/image';
import Modal, { ModalContent } from '@front/web-ui/src/components/modal/modal';
import { useIsMobile } from '@front/web-ui/src/styles/media-queries';

const t = translate('basket.eligible_pros_count.modal');

const Paragraph = styled.div`
  margin-top: 20px;
`;

const StyledImage = styled(Image)`
  width: 100%;
  height: auto;
  border-radius: 10px;
`;
type EligibleProsCountModalProps = {
  onClose: () => void;
  isOpen: boolean;
  universeRef: UniverseReference;
};

const EligibleProsCountModal = ({ onClose, isOpen, universeRef }: EligibleProsCountModalProps) => {
  const title = t('.title', { jobTitle: t(`universes.${universeRef}.dont_care`) });
  const isMobile = useIsMobile();
  return (
    <Modal
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      primaryButton={{ children: t('base.got_it'), onPress: onClose }}
    >
      <ModalContent>
        {isMobile ? (
          <StyledImage
            src={proWithMedalMobile}
            double={proWithMedalMobile2x}
            triple={proWithMedalMobile3x}
            alt={title}
          />
        ) : (
          <StyledImage
            src={proWithMedalDesktop}
            double={proWithMedalDesktop2x}
            triple={proWithMedalDesktop3x}
            alt={title}
          />
        )}
        <Paragraph>
          <Text>{t(`.paragraph_1.${universeRef}`)}</Text>
        </Paragraph>
        <Paragraph>
          <Text>{t('.paragraph_2')}</Text>
        </Paragraph>
        <Paragraph>
          <Text>{t('.paragraph_3')}</Text>
        </Paragraph>
      </ModalContent>
    </Modal>
  );
};

export default EligibleProsCountModal;
